import script from "./CopyableText.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyableText.vue?vue&type=script&setup=true&lang=ts"

import "./CopyableText.vue?vue&type=style&index=0&id=07d03016&lang=scss"

const __exports__ = script;

export default __exports__